import React from 'react';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToBuy = () => {
    const element = document.getElementById('offer');
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative w-full bg-navy pt-10 pb-10 px-6 md:pt-16 md:pb-16 overflow-hidden" data-id="element-53">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-54">
        <h1 className="font-serif text-4xl md:text-6xl text-gold mb-3 leading-tight" data-id="element-55">
          Silencia a la <br className="md:hidden" data-id="element-56" />
          "Mamá Juez"
        </h1>

        <p className="font-sans text-lg md:text-xl text-cream/90 mb-8 max-w-xl leading-relaxed" data-id="element-57">
          La guía práctica de 14 días para Ordenar tu diálogo interno sin
          exigencias imposibles.
        </p>

        {/* Product Mockup */}
        <div className="relative w-full max-w-sm mx-auto mb-8" data-id="element-58">
          <div className="absolute inset-0 bg-gold/20 blur-3xl rounded-full opacity-30" data-id="element-59"></div>
          <img src="https://cdn.magicpatterns.com/uploads/daRwLhkLWduhSxzd84PeoT/mockup.png" alt="Silencia a la Mamá Juez en tablet" width={400} height={500} className="relative z-10 w-full h-auto drop-shadow-2xl rounded-lg" data-id="element-60" />
        </div>

        {/* Opening Lead */}
        <div className="text-left w-full max-w-2xl mb-8" data-id="element-61">
          <div className="font-serif italic text-lg md:text-2xl text-cream/90 space-y-4 leading-relaxed border-l-2 border-gold/30 pl-6" data-id="element-62">
            <p data-id="element-63">Hay un tipo de cansancio que no se quita durmiendo.</p>
            <p data-id="element-64">Es el cansancio de sentirte evaluada.</p>
            <p data-id="element-65">
              Trabajas… y sientes que abandonas.
              <br data-id="element-66" />
              Te quedas en casa… y sientes que no aportas.
            </p>
            <p data-id="element-67">Haces mil cosas… y aun así esa voz aparece, seca, puntual:</p>
            <p className="text-gold text-xl md:text-3xl not-italic font-bold" data-id="element-68">
              "Deberías hacerlo mejor."
            </p>
            <p data-id="element-69">
              Y lo peor no es la voz.
              <br data-id="element-70" />
              Lo peor es que, con el tiempo, empiezas a creer que esa voz es "la
              realidad".
            </p>
          </div>
        </div>

        {/* Benefits block */}
        <div className="text-left w-full max-w-2xl mb-8 bg-white/5 rounded-lg p-6 border border-gold/20" data-id="element-71">
          <p className="font-serif text-xl md:text-2xl text-gold mb-4 not-italic font-bold" data-id="element-72">
            En 14 días vas a poder:
          </p>
          <ul className="space-y-2 font-sans text-cream/90 text-lg" data-id="element-73">
            <li className="flex items-start gap-2" data-id="element-74">
              <span className="text-gold mt-0.5" data-id="element-75">✔</span>
              <span data-id="element-76">Detectar cuándo aparece esa voz crítica</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-77">
              <span className="text-gold mt-0.5" data-id="element-78">✔</span>
              <span data-id="element-79">Diferenciar pensamiento de realidad</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-80">
              <span className="text-gold mt-0.5" data-id="element-81">✔</span>
              <span data-id="element-82">Tomar decisiones con más claridad</span>
            </li>
            <li className="flex items-start gap-2" data-id="element-83">
              <span className="text-gold mt-0.5" data-id="element-84">✔</span>
              <span data-id="element-85">Terminar el día con sensación de orden mental</span>
            </li>
          </ul>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center w-full max-w-sm" data-id="element-86">
          <button onClick={scrollToBuy} className="w-full bg-gold hover:bg-gold/90 text-navy font-bold py-4 px-8 rounded shadow-[0_0_20px_rgba(201,168,76,0.3)] transition-all hover:scale-[1.02] flex items-center justify-center gap-2 text-lg" data-id="element-87">
            Quiero Conocer la Guía
            <ArrowRight className="w-5 h-5" data-id="element-88" />
          </button>
        </div>
      </div>
    </section>;
}